/**
 * Which of a template's areas (slots) counts as the page body: where new
 * sections go when nothing is selected, and where a section preview puts the
 * section. Templates name their main column differently, and a few have none.
 */

/** The header and footer areas every template has. */
export const EDGE_SLOTS = ['menu-bar', 'footer'];

/** Main-column areas, in order of preference. */
export const BODY_SLOTS = ['content', 'left-col', 'top-section', 'additional-content', 'right-col'];

/** The template's main area, or else its first area that isn't the header or footer; null when it has only those. */
export const bodySlotOf = (slotIds: string[]): string | null => {
  const known = slotIds.filter(Boolean);
  return BODY_SLOTS.find(id => known.includes(id)) || known.find(id => !EDGE_SLOTS.includes(id)) || null;
};

/**
 * Where a section goes when no place was picked: the body, or at the end of the
 * header for templates without one (the template's own content follows it).
 */
export const defaultSlotOf = (slotIds: string[]): string => bodySlotOf(slotIds) || 'menu-bar';
